/* tslint:disable */
/* eslint-disable */
/**
 * grpc/v1/landings_service.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from '../configuration'
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios'
import globalAxios from 'axios'
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common'
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from '../base'
// @ts-ignore
import type { RequestArgs } from '../base'
// @ts-ignore
import { RpcStatus } from '../models'
// @ts-ignore
import { V1GetDeployStatusResponse } from '../models'
// @ts-ignore
import { V1GetLandingResponse } from '../models'
// @ts-ignore
import { V1GetLandingSeoResponse } from '../models'
// @ts-ignore
import { V1GetPublishManifestResponse } from '../models'
// @ts-ignore
import { V1LandingSeo } from '../models'
// @ts-ignore
import { V1ListLandingsResponse } from '../models'
// @ts-ignore
import { V1PublishLandingResponse } from '../models'
// @ts-ignore
import { V1RecordLandingViewRequest } from '../models'
// @ts-ignore
import { V1RecordLandingViewResponse } from '../models'
// @ts-ignore
import { V1UnpublishLandingResponse } from '../models'
// @ts-ignore
import { V1UpdateLandingSeoResponse } from '../models'
/**
 * LandingsServiceApi - axios parameter creator
 * @export
 */
export const LandingsServiceApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary GetDeployStatus — последний deploy-статус лендинга (из БД, по имени).
     * @param {string} name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    landingsServiceGetDeployStatus: async (
      name: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'name' is not null or undefined
      assertParamExists('landingsServiceGetDeployStatus', 'name', name)
      const localVarPath = `/api/v1/landings/{name}/status`.replace(
        `{${'name'}}`,
        encodeURIComponent(String(name)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary GetLanding — один лендинг по имени.
     * @param {string} name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    landingsServiceGetLanding: async (
      name: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'name' is not null or undefined
      assertParamExists('landingsServiceGetLanding', 'name', name)
      const localVarPath = `/api/v1/landings/{name}`.replace(
        `{${'name'}}`,
        encodeURIComponent(String(name)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary GetLandingSeo — настройки индексации и мета-тегов лендинга (DEV-1783, ADR-0048).
     * @param {string} name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    landingsServiceGetLandingSeo: async (
      name: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'name' is not null or undefined
      assertParamExists('landingsServiceGetLandingSeo', 'name', name)
      const localVarPath = `/api/v1/landings/{name}/seo`.replace(
        `{${'name'}}`,
        encodeURIComponent(String(name)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary GetPublishManifest — то, что уедет на прод при следующей публикации: готовый набор тегов страницы и флаг включения в карту сайта. Читает CRM («что уедет на прод») и переносит в вёрстку джоба публикации.
     * @param {string} name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    landingsServiceGetPublishManifest: async (
      name: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'name' is not null or undefined
      assertParamExists('landingsServiceGetPublishManifest', 'name', name)
      const localVarPath = `/api/v1/landings/{name}/manifest`.replace(
        `{${'name'}}`,
        encodeURIComponent(String(name)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary ListLandings — список лендингов из registry.yaml.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    landingsServiceListLandings: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/landings`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary PublishLanding — триггер публикации (ACTION=publish).
     * @param {string} name
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    landingsServicePublishLanding: async (
      name: string,
      body: object,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'name' is not null or undefined
      assertParamExists('landingsServicePublishLanding', 'name', name)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('landingsServicePublishLanding', 'body', body)
      const localVarPath = `/api/v1/landings/{name}/publish`.replace(
        `{${'name'}}`,
        encodeURIComponent(String(name)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Осознанный риск ADR: просмотры накручиваемы. Портит только внутреннюю метрику, PII метод не принимает и не хранит.
     * @summary RecordLandingView — приём просмотра лендинга (DEV-1086, ADR-0022 ред.2 §3.5). ПУБЛИЧНЫЙ метод без авторизации: бьют middleware Cloudflare Pages (внешний рекламный лендинг) и beacon GCS-лендингов. Событие уходит в шину через outbox, analytics считает конверсию по слагу.
     * @param {V1RecordLandingViewRequest} body RecordLandingViewRequest — один просмотр лендинга.  Времени просмотра в запросе нет намеренно: метод публичный, клиентскому времени в фактах аналитики доверять нельзя — timestamp ставит приёмник. Тело от Pages Function содержит лишнее поле viewed_at, gateway его гасит (DiscardUnknown), и это ожидаемо.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    landingsServiceRecordLandingView: async (
      body: V1RecordLandingViewRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('landingsServiceRecordLandingView', 'body', body)
      const localVarPath = `/api/v1/landings/views`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary UnpublishLanding — триггер снятия (ACTION=unpublish).
     * @param {string} name
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    landingsServiceUnpublishLanding: async (
      name: string,
      body: object,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'name' is not null or undefined
      assertParamExists('landingsServiceUnpublishLanding', 'name', name)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('landingsServiceUnpublishLanding', 'body', body)
      const localVarPath = `/api/v1/landings/{name}/unpublish`.replace(
        `{${'name'}}`,
        encodeURIComponent(String(name)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary UpdateLandingSeo — полная замена настроек SEO лендинга.
     * @param {string} name
     * @param {V1LandingSeo} seo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    landingsServiceUpdateLandingSeo: async (
      name: string,
      seo: V1LandingSeo,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'name' is not null or undefined
      assertParamExists('landingsServiceUpdateLandingSeo', 'name', name)
      // verify required parameter 'seo' is not null or undefined
      assertParamExists('landingsServiceUpdateLandingSeo', 'seo', seo)
      const localVarPath = `/api/v1/landings/{name}/seo`.replace(
        `{${'name'}}`,
        encodeURIComponent(String(name)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        seo,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * LandingsServiceApi - functional programming interface
 * @export
 */
export const LandingsServiceApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = LandingsServiceApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary GetDeployStatus — последний deploy-статус лендинга (из БД, по имени).
     * @param {string} name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async landingsServiceGetDeployStatus(
      name: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetDeployStatusResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.landingsServiceGetDeployStatus(
        name,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['LandingsServiceApi.landingsServiceGetDeployStatus']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary GetLanding — один лендинг по имени.
     * @param {string} name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async landingsServiceGetLanding(
      name: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetLandingResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.landingsServiceGetLanding(
        name,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['LandingsServiceApi.landingsServiceGetLanding']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary GetLandingSeo — настройки индексации и мета-тегов лендинга (DEV-1783, ADR-0048).
     * @param {string} name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async landingsServiceGetLandingSeo(
      name: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetLandingSeoResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.landingsServiceGetLandingSeo(
        name,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['LandingsServiceApi.landingsServiceGetLandingSeo']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary GetPublishManifest — то, что уедет на прод при следующей публикации: готовый набор тегов страницы и флаг включения в карту сайта. Читает CRM («что уедет на прод») и переносит в вёрстку джоба публикации.
     * @param {string} name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async landingsServiceGetPublishManifest(
      name: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetPublishManifestResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.landingsServiceGetPublishManifest(
        name,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['LandingsServiceApi.landingsServiceGetPublishManifest']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary ListLandings — список лендингов из registry.yaml.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async landingsServiceListLandings(
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListLandingsResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.landingsServiceListLandings(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['LandingsServiceApi.landingsServiceListLandings']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary PublishLanding — триггер публикации (ACTION=publish).
     * @param {string} name
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async landingsServicePublishLanding(
      name: string,
      body: object,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PublishLandingResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.landingsServicePublishLanding(
        name,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['LandingsServiceApi.landingsServicePublishLanding']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Осознанный риск ADR: просмотры накручиваемы. Портит только внутреннюю метрику, PII метод не принимает и не хранит.
     * @summary RecordLandingView — приём просмотра лендинга (DEV-1086, ADR-0022 ред.2 §3.5). ПУБЛИЧНЫЙ метод без авторизации: бьют middleware Cloudflare Pages (внешний рекламный лендинг) и beacon GCS-лендингов. Событие уходит в шину через outbox, analytics считает конверсию по слагу.
     * @param {V1RecordLandingViewRequest} body RecordLandingViewRequest — один просмотр лендинга.  Времени просмотра в запросе нет намеренно: метод публичный, клиентскому времени в фактах аналитики доверять нельзя — timestamp ставит приёмник. Тело от Pages Function содержит лишнее поле viewed_at, gateway его гасит (DiscardUnknown), и это ожидаемо.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async landingsServiceRecordLandingView(
      body: V1RecordLandingViewRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1RecordLandingViewResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.landingsServiceRecordLandingView(
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['LandingsServiceApi.landingsServiceRecordLandingView']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary UnpublishLanding — триггер снятия (ACTION=unpublish).
     * @param {string} name
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async landingsServiceUnpublishLanding(
      name: string,
      body: object,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1UnpublishLandingResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.landingsServiceUnpublishLanding(
        name,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['LandingsServiceApi.landingsServiceUnpublishLanding']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary UpdateLandingSeo — полная замена настроек SEO лендинга.
     * @param {string} name
     * @param {V1LandingSeo} seo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async landingsServiceUpdateLandingSeo(
      name: string,
      seo: V1LandingSeo,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1UpdateLandingSeoResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.landingsServiceUpdateLandingSeo(
        name,
        seo,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['LandingsServiceApi.landingsServiceUpdateLandingSeo']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * LandingsServiceApi - factory interface
 * @export
 */
export const LandingsServiceApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = LandingsServiceApiFp(configuration)
  return {
    /**
     *
     * @summary GetDeployStatus — последний deploy-статус лендинга (из БД, по имени).
     * @param {string} name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    landingsServiceGetDeployStatus(
      name: string,
      options?: any,
    ): AxiosPromise<V1GetDeployStatusResponse> {
      return localVarFp
        .landingsServiceGetDeployStatus(name, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary GetLanding — один лендинг по имени.
     * @param {string} name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    landingsServiceGetLanding(name: string, options?: any): AxiosPromise<V1GetLandingResponse> {
      return localVarFp
        .landingsServiceGetLanding(name, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary GetLandingSeo — настройки индексации и мета-тегов лендинга (DEV-1783, ADR-0048).
     * @param {string} name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    landingsServiceGetLandingSeo(
      name: string,
      options?: any,
    ): AxiosPromise<V1GetLandingSeoResponse> {
      return localVarFp
        .landingsServiceGetLandingSeo(name, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary GetPublishManifest — то, что уедет на прод при следующей публикации: готовый набор тегов страницы и флаг включения в карту сайта. Читает CRM («что уедет на прод») и переносит в вёрстку джоба публикации.
     * @param {string} name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    landingsServiceGetPublishManifest(
      name: string,
      options?: any,
    ): AxiosPromise<V1GetPublishManifestResponse> {
      return localVarFp
        .landingsServiceGetPublishManifest(name, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary ListLandings — список лендингов из registry.yaml.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    landingsServiceListLandings(options?: any): AxiosPromise<V1ListLandingsResponse> {
      return localVarFp
        .landingsServiceListLandings(options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary PublishLanding — триггер публикации (ACTION=publish).
     * @param {string} name
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    landingsServicePublishLanding(
      name: string,
      body: object,
      options?: any,
    ): AxiosPromise<V1PublishLandingResponse> {
      return localVarFp
        .landingsServicePublishLanding(name, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Осознанный риск ADR: просмотры накручиваемы. Портит только внутреннюю метрику, PII метод не принимает и не хранит.
     * @summary RecordLandingView — приём просмотра лендинга (DEV-1086, ADR-0022 ред.2 §3.5). ПУБЛИЧНЫЙ метод без авторизации: бьют middleware Cloudflare Pages (внешний рекламный лендинг) и beacon GCS-лендингов. Событие уходит в шину через outbox, analytics считает конверсию по слагу.
     * @param {V1RecordLandingViewRequest} body RecordLandingViewRequest — один просмотр лендинга.  Времени просмотра в запросе нет намеренно: метод публичный, клиентскому времени в фактах аналитики доверять нельзя — timestamp ставит приёмник. Тело от Pages Function содержит лишнее поле viewed_at, gateway его гасит (DiscardUnknown), и это ожидаемо.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    landingsServiceRecordLandingView(
      body: V1RecordLandingViewRequest,
      options?: any,
    ): AxiosPromise<V1RecordLandingViewResponse> {
      return localVarFp
        .landingsServiceRecordLandingView(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary UnpublishLanding — триггер снятия (ACTION=unpublish).
     * @param {string} name
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    landingsServiceUnpublishLanding(
      name: string,
      body: object,
      options?: any,
    ): AxiosPromise<V1UnpublishLandingResponse> {
      return localVarFp
        .landingsServiceUnpublishLanding(name, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary UpdateLandingSeo — полная замена настроек SEO лендинга.
     * @param {string} name
     * @param {V1LandingSeo} seo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    landingsServiceUpdateLandingSeo(
      name: string,
      seo: V1LandingSeo,
      options?: any,
    ): AxiosPromise<V1UpdateLandingSeoResponse> {
      return localVarFp
        .landingsServiceUpdateLandingSeo(name, seo, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * LandingsServiceApi - object-oriented interface
 * @export
 * @class LandingsServiceApi
 * @extends {BaseAPI}
 */
export class LandingsServiceApi extends BaseAPI {
  /**
   *
   * @summary GetDeployStatus — последний deploy-статус лендинга (из БД, по имени).
   * @param {string} name
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LandingsServiceApi
   */
  public landingsServiceGetDeployStatus(name: string, options?: RawAxiosRequestConfig) {
    return LandingsServiceApiFp(this.configuration)
      .landingsServiceGetDeployStatus(name, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary GetLanding — один лендинг по имени.
   * @param {string} name
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LandingsServiceApi
   */
  public landingsServiceGetLanding(name: string, options?: RawAxiosRequestConfig) {
    return LandingsServiceApiFp(this.configuration)
      .landingsServiceGetLanding(name, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary GetLandingSeo — настройки индексации и мета-тегов лендинга (DEV-1783, ADR-0048).
   * @param {string} name
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LandingsServiceApi
   */
  public landingsServiceGetLandingSeo(name: string, options?: RawAxiosRequestConfig) {
    return LandingsServiceApiFp(this.configuration)
      .landingsServiceGetLandingSeo(name, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary GetPublishManifest — то, что уедет на прод при следующей публикации: готовый набор тегов страницы и флаг включения в карту сайта. Читает CRM («что уедет на прод») и переносит в вёрстку джоба публикации.
   * @param {string} name
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LandingsServiceApi
   */
  public landingsServiceGetPublishManifest(name: string, options?: RawAxiosRequestConfig) {
    return LandingsServiceApiFp(this.configuration)
      .landingsServiceGetPublishManifest(name, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary ListLandings — список лендингов из registry.yaml.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LandingsServiceApi
   */
  public landingsServiceListLandings(options?: RawAxiosRequestConfig) {
    return LandingsServiceApiFp(this.configuration)
      .landingsServiceListLandings(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary PublishLanding — триггер публикации (ACTION=publish).
   * @param {string} name
   * @param {object} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LandingsServiceApi
   */
  public landingsServicePublishLanding(
    name: string,
    body: object,
    options?: RawAxiosRequestConfig,
  ) {
    return LandingsServiceApiFp(this.configuration)
      .landingsServicePublishLanding(name, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Осознанный риск ADR: просмотры накручиваемы. Портит только внутреннюю метрику, PII метод не принимает и не хранит.
   * @summary RecordLandingView — приём просмотра лендинга (DEV-1086, ADR-0022 ред.2 §3.5). ПУБЛИЧНЫЙ метод без авторизации: бьют middleware Cloudflare Pages (внешний рекламный лендинг) и beacon GCS-лендингов. Событие уходит в шину через outbox, analytics считает конверсию по слагу.
   * @param {V1RecordLandingViewRequest} body RecordLandingViewRequest — один просмотр лендинга.  Времени просмотра в запросе нет намеренно: метод публичный, клиентскому времени в фактах аналитики доверять нельзя — timestamp ставит приёмник. Тело от Pages Function содержит лишнее поле viewed_at, gateway его гасит (DiscardUnknown), и это ожидаемо.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LandingsServiceApi
   */
  public landingsServiceRecordLandingView(
    body: V1RecordLandingViewRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return LandingsServiceApiFp(this.configuration)
      .landingsServiceRecordLandingView(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary UnpublishLanding — триггер снятия (ACTION=unpublish).
   * @param {string} name
   * @param {object} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LandingsServiceApi
   */
  public landingsServiceUnpublishLanding(
    name: string,
    body: object,
    options?: RawAxiosRequestConfig,
  ) {
    return LandingsServiceApiFp(this.configuration)
      .landingsServiceUnpublishLanding(name, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary UpdateLandingSeo — полная замена настроек SEO лендинга.
   * @param {string} name
   * @param {V1LandingSeo} seo
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LandingsServiceApi
   */
  public landingsServiceUpdateLandingSeo(
    name: string,
    seo: V1LandingSeo,
    options?: RawAxiosRequestConfig,
  ) {
    return LandingsServiceApiFp(this.configuration)
      .landingsServiceUpdateLandingSeo(name, seo, options)
      .then((request) => request(this.axios, this.basePath))
  }
}
